import {useQuery} from '@tanstack/react-query';

const loadScript = (
  src: string,
  async = true,
  type = 'text/javascript',
): Promise<{loaded: boolean; error: boolean; message?: boolean}> => {
  return new Promise((resolve, reject) => {
    try {
      const tag = document.createElement('script');
      const container = document.head || document.body;

      tag.type = type;
      tag.async = async;
      tag.src = src;

      tag.addEventListener('load', () => {
        resolve({loaded: true, error: false});
      });

      tag.addEventListener('error', () => {
        reject({
          loaded: false,
          error: true,
          message: `Failed to load script with src ${src}`,
        });
      });

      container.appendChild(tag);
    } catch (error) {
      reject(error);
    }
  });
};

export const useExternalScript = (url: string | undefined) => {
  return useQuery({
    queryKey: ['external-script', url],
    queryFn: () => loadScript(url!),
    enabled: !!url,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
